import { useAuth } from "@/contexts/AuthContext";
import { canPerform } from "@/config/constants";

export function usePermission() {
    const { user } = useAuth();
    const role = user?.role;
    return {
        role,
        can: (resource, action) => canPerform(role, resource, action),
        isAdmin: role === "Administrator",
    };
}
